import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { BASE_CONSTANTS } from "@tci/common";
import { NgTenantsNotAvailableComponent } from "./ng-tenants-not-available.component";

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: BASE_CONSTANTS.TENANTS_NOT_AVAILABLE,
                component: NgTenantsNotAvailableComponent
            }
        ])
    ],
    exports: [
        RouterModule
    ]
})
export class NgTenantsNotAvailableRoutingModule { }
